const doc = [({"en":({"js":({"routes":({"user":({"unicorn":({"you_are_so_cool_unicorn_go_go":"You are so cool UNICORN gogo", "analysis":"Analysis"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;